import React from "react";
import {GoChevronLeft, GoChevronRight} from "react-icons/go";

const imageViewControls = ({currentPage, setCurrentPage, numPages}) => {
    const nextPage = () => {
        if (currentPage < numPages - 1) setCurrentPage(prevState => prevState + 1);
    };

    const previousPage = () => {
        if (currentPage > 0) setCurrentPage(prevState => prevState - 1);
    };

    return (
        <div className="space-y-2 flex flex-col items-center h-10">
            <div className="rounded flex-shrink-0 h-full flex items-center text-white space-x-3 px-3">
                <button
                    className="w-8 h-8 flex items-center justify-center hover:bg-black text-white rounded-full transition"
                    onClick={previousPage}
                >
                    <GoChevronLeft className="w-7 h-7"/>
                </button>

                <div className="bg-black bg-opacity-50 text-white rounded px-3 py-1">
                    {currentPage + 1} / {numPages}
                </div>

                <button
                    className="w-8 h-8 flex items-center justify-center hover:bg-black text-white rounded-full transition"
                    onClick={nextPage}
                >
                    <GoChevronRight className="w-7 h-7"/>
                </button>
            </div>
        </div>
    );
};

export default imageViewControls;
